import { render, staticRenderFns } from "./PostInPccModal.vue?vue&type=template&id=6875cba2&scoped=true&"
import script from "./PostInPccModal.vue?vue&type=script&lang=ts&"
export * from "./PostInPccModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6875cba2",
  null
  
)

export default component.exports